export function NumberIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M17.242 3.03a1 1 0 01.728 1.213L17.03 8H20a1 1 0 110 2h-3.47l-1 4H18a1 1 0 110 2h-2.97l-1.06 4.242a1 1 0 01-1.94-.485L12.97 16H9.03l-1.06 4.242a1 1 0 01-1.94-.485L6.97 16H4a1 1 0 110-2h3.47l1-4H6a1 1 0 010-2h2.97l1.06-4.243a1 1 0 111.94.486L11.03 8h3.94l1.06-4.243a1 1 0 011.212-.727zM10.531 10l-1 4h3.938l1-4h-3.938z"
      ></path>
    </svg>
  );
}
